

































import { Vue, Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { majorNoticeText } from "@/common/constants/index";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import ActivityNameModal from "@/components/common/edit/ActivityNameModal.vue";

@Component({
  components: {
    "dash-line": DashLine,
    "activity-label": ActivityLabel,
    "activity-name-modal": ActivityNameModal,
  },
})
export default class ActivityName extends Vue {
  @Getter("documentTitle") documentTitle!: string;
  @Getter("section") section: any;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("xmMajordomo") xmMajordomo!: boolean;
  @Getter("xcxType") xcxType!: string;
  @Action("changeDocumentTitle") changeDocumentTitle!: Function;
  @Action("changeShowFooter") changeShowFooter!: Function;

  showModal: boolean = false;

  get getterDocumentTitle(): string {
    return this.documentTitle;
  }

  set getterDocumentTitle(val: string) {
    this.changeDocumentTitle(val);
  }

  handleShowModal() {
     if(this.xcxType ==='mkb'){
      return
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定",
      });
      return;
    }

    this.showModal = true;
    this.changeShowFooter(false);
  }

  handleHideModal() {
    this.showModal = false;
    this.changeShowFooter(true);
  }
}
